import {Button, GoogleExtensionIcon} from '@blesk-frontend/ui';
import {useNavigate} from '@tanstack/react-router';

import {downloadLinkByPlatformMap} from '@/libs';

export const AuthInstallAgent = () => {
  const navigate = useNavigate();

  const onClickInstall = () => {
    navigate({to: '/'});
  };

  return (
    <div className="mx-auto max-w-96 py-6">
      <div className="flex flex-col gap-8">
        <div className="flex flex-col items-center gap-6">
          <GoogleExtensionIcon />
          <h1 className="text-center text-title-h1">
            Установите наше
            <br />
            расширение для браузера
          </h1>
          <p className="text-center text-paragraph-lg text-text-secondary">
            Для создания инструкций в браузере требуется расширение Blesk
          </p>
          <a
            href="https://chromewebstore.google.com/detail/blesk/bombgjmnkojifbkkmnhfanibpccelgda"
            target="_blank"
            rel="noreferrer"
          >
            <Button onClick={onClickInstall}>Перейти в Chrome Store и установить</Button>
          </a>
        </div>
        <div className="h-px w-full bg-border-primary" />
        <div className="flex flex-col items-center gap-6">
          <p className="text-center text-paragraph-lg text-text-secondary">
            Для создания пошаговых инструкций для&nbsp;windows-приложений вам&nbsp;потребуется Blesk
            для Windows
          </p>
          <a
            className="text-brand-secondary text-paragraph-lg"
            href={downloadLinkByPlatformMap.get('windows')}
            onClick={onClickInstall}
          >
            Скачать Blesk для Windows
          </a>
        </div>
      </div>
    </div>
  );
};
